import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import logo from "../../../Assets/securenet-logo-agreement.png";

const CustomerAgreementDetailsPrint = () => {
  const location = useLocation();
  const [printed, setPrinted] = useState(false);

  const stateData = location.state || {};
  const agreementData = stateData.agreement || {};
  const userData = stateData.user || {};

  const {
    location: agreementLocation = 'N/A',
    bankAccountNumber = 'N/A',
    ifscCode = 'N/A',
    partnerNameFirmName = 'N/A',
    contactPersonName = 'N/A',
    mobileNumber = 'N/A',
    address = 'N/A',
    purchaseDistributor = 'N/A',
    authorizedDistributorForRegion = 'N/A',
    distributorLocation = 'N/A',
  } = agreementData;

  const handlePrint = () => {
    window.print();
  };

  useEffect(() => {
    const afterPrint = () => {
      setPrinted(true);
    };

    window.addEventListener('afterprint', afterPrint);
    return () => {
      window.removeEventListener('afterprint', afterPrint);
    };
  }, []);

  return (
    <div className="flex flex-col items-center mt-14 min-h-screen p-4">
      <style>
        {`
          @page {
            size: A4 portrait;
            margin: 10mm;
          }

          @media print {
            body * {
              visibility: hidden;
            }

            .print-container, .print-container * {
              visibility: visible;
            }

            .print-container {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              background: white;
              box-shadow: none;
            }

            .no-print {
              display: none !important;
            }

            body {
              background: white;
              margin: 0;
              padding: 0;
            }
          }
        `}
      </style>

      {/* Document Container */}
      <div className="print-container bg-white p-8 w-[210mm] min-h-[297mm] mx-auto">
        <div className="flex justify-between items-start mb-4">
          <div>
            {/* Optional title can go here */}
          </div>
          <div>
            <img
              src={logo}
              alt="Securenet Logo"
              className="w-48 h-auto object-contain"
            />
          </div>
        </div>

        {/* Letter Content */}
        <div className="mb-4 text-sm leading-snug">
          <p className="mb-2">Dear Sir,</p>
          <p className="mb-4 text-justify">
            This letter formally invites you to sign target acceptance against
            Category "Micro Distributor" Partner. To be eligible for Quarterly
            payout as an Authorized Micro Distributor.
          </p>
        </div>

        <div className="mb-4">
          <div className="flex items-center mb-2">
            <p className="font-semibold mb-1 mr-2 text-sm">LOCATION:</p>
            <div className="border-b border-black flex-grow">
              <span className="block py-1 px-2 text-sm">{agreementLocation}</span>
            </div>
          </div>

          {/* Targets Table */}
          <table className="w-full border-collapse border border-gray-800 mb-4 text-xs">
            <tbody>
              <tr>
                <td className="border border-gray-800 p-1 font-semibold">
                  QUARTER VALID FOR
                </td>
                <td className="border border-gray-800 p-1">
                  April to June (Q1) -- AMJ
                </td>
              </tr>
              <tr>
                <td className="border border-gray-800 p-1 font-semibold" colSpan="2">
                  TOD as per the following details:
                </td>
              </tr>
              <tr>
                <td className="border border-gray-800 p-1 font-semibold w-1/2">
                  Buying Target
                </td>
                <td className="border border-gray-800 p-1 font-semibold w-1/2">
                  Payout %
                </td>
              </tr>
              <tr>
                <td className="border border-gray-800 p-1">1.5 lac + GST</td>
                <td className="border border-gray-800 p-1">1%</td>
              </tr>
              <tr>
                <td className="border border-gray-800 p-1">2.5 Lac+ GST</td>
                <td className="border border-gray-800 p-1">1.5%</td>
              </tr>
              <tr>
                <td className="border border-gray-800 p-1">3.5 Lac+ GST</td>
                <td className="border border-gray-800 p-1">2.5%</td>
              </tr>
            </tbody>
          </table>

          {/* Bank Details */}
          <div className="grid grid-cols-1 gap-2 mb-4 text-sm">
            <div className="flex items-center">
              <p className="font-semibold mr-2">BANK ACCOUNT NO.</p>
              <div className="border-b border-black flex-grow">
                <span className="block py-1 px-2">{bankAccountNumber}</span>
              </div>
            </div>
            <div className="flex items-center">
              <p className="font-semibold mr-2">IFSC CODE:</p>
              <div className="border-b border-black flex-grow">
                <span className="block py-1 px-2">{ifscCode}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Terms and Conditions */}
        <div className="mb-4">
          <h2 className="text-sm font-bold mb-1 text-blue-400 underline">
            Terms and Conditions:
          </h2>
          <ol className="list-decimal pl-5 space-y-1 text-xs leading-tight">
            <li className="mb-1">
              The Securenet incentive payout would be booked in the name of the
              participating Micro Distributor partner only as per the details
              mentioned in the target and acceptance letter.
            </li>
            <li className="mb-1">
              This letter is strictly personalized for you and not transferrable
              in any case.
            </li>
            <li className="mb-1">
              You need to purchase Securenet products from <strong>{distributorLocation}</strong> specified distributor <strong>{authorizedDistributorForRegion}</strong> Authorized Distributor for your region only <strong>{purchaseDistributor}</strong>
            </li>
            <li className="mb-1">
              SPC (B2B AND SPECIAL PRICE BILLING) will not be considered for
              target and TOD payout.
            </li>
            <li className="mb-1">
              SSD, TONNER, RAM and Neo Series Products will not be counted for
              TOD.
            </li>
            <li className="mb-1">
              <strong>Min.30% monthly target must be achieved</strong> to be
              eligible for quarterly payout and maintain Micro distributor
              status.
            </li>
            <li className="mb-1">
              Your name will be published in our website as Auth. Micro
              distributor.
            </li>
            <li className="mb-1">
              Your invoices will be valid for company schemes being run from
              company time to time for partners aligned with you.
            </li>
            <li className="mb-1">
              Your aligned partners will be recognized by company as auth
              partners, certificates will be given to them after registration on
              company website.
            </li>
            <li className="mb-1">
              This program letter is valid for 1 quarter <strong>only</strong>.
            </li>
            <li className="mb-1">The company's decision is final regarding any dispute.</li>
          </ol>
        </div>

        {/* Acknowledgement Section */}
        <div className="mt-4 text-sm">
          <h3 className="font-bold underline mb-1 text-sm text-center">
            Acknowledgement By Partner
          </h3>

          <p className="mb-2 text-justify">
            I hereby agree to the terms and conditions mentioned herein and wish
            to participate with this target.
          </p>

          <div className="grid grid-cols-1 gap-2 mb-2">
            <div className="flex items-center">
              <p className="font-semibold mr-2">Firm/Company Name:</p>
              <div className="border-b border-black flex-grow">
                <span className="block py-1 px-2">{partnerNameFirmName}</span>
              </div>
            </div>
            <div className="flex items-center">
              <p className="font-semibold mr-2">Contact Person Name:</p>
              <div className="border-b border-black flex-grow">
                <span className="block py-1 px-2">{contactPersonName}</span>
              </div>
            </div>
            <div className="flex items-center">
              <p className="font-semibold mr-2">Mobile no:</p>
              <div className="border-b border-black flex-grow">
                <span className="block py-1 px-2">{mobileNumber}</span>
              </div>
            </div>
            <div className="flex items-center">
              <p className="font-semibold mr-2">Address:</p>
              <div className="border-b border-black flex-grow">
                <span className="block py-1 px-2">{address}</span>
              </div>
            </div>
          </div>

          <div className="mt-6 text-left text-xs">
          <p className="mb-1 inline">
            Approved and Digitally Validated by Securenet Representative – Authorized Signatory
            </p>
            {/* <p className="font-semibold inline ml-2">
              Validated by Securenet representative
            </p> */}
          </div>
        </div>
      </div>

      {/* Print Button */}
      <button
        onClick={handlePrint}
        className="fixed bottom-8 right-8 bg-[#1C50A3] text-white px-6 py-3 rounded-lg hover:bg-[#1C50A3] transition-colors no-print shadow-lg"
      >
        Print Agreement
      </button>

      {printed && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50 no-print">
          <div className="bg-white p-6 rounded-lg shadow-xl">
            <h3 className="text-lg font-bold mb-4">Print Successful</h3>
            <p className="mb-4">The document has been printed successfully.</p>
            <button 
              onClick={() => setPrinted(false)}
              className="bg-[#1C50A3] text-white px-4 py-2 rounded hover:bg-[#1C50A3]"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerAgreementDetailsPrint;